import React, { createContext, useContext, useState, useEffect } from 'react';
import { doc, onSnapshot } from 'firebase/firestore';
import { db, appId } from '../config/firebase';
import { getDefaultModel } from '../utils/aiApiHelper';

const AiProviderContext = createContext();

export const AiProvider = ({ children }) => {
    // Default initial state
    const [aiModel, setAiModel] = useState({
        provider: 'groq',
        model: 'openai/gpt-oss-20b'
    });

    // Load settings from admin config and listen for real-time updates
    useEffect(() => {
        const settingsRef = doc(db, `artifacts/${appId}/settings/global`);

        const unsubscribe = onSnapshot(settingsRef, (snapshot) => {
            if (snapshot.exists()) {
                const data = snapshot.data();
                const provider = data.aiSettings?.defaultProvider || 'groq';
                const model = getDefaultModel(provider);

                setAiModel({ provider, model });
                console.log('🤖 AI Provider updated from Settings:', provider, model);
            }
        }, (error) => {
            console.error('Error listening to AI settings:', error);
        });

        return () => unsubscribe();
    }, []);

    const value = { aiModel, setAiModel };
    return (
        <AiProviderContext.Provider value={value}>
            {children}
        </AiProviderContext.Provider>
    );
};

export const useAiProvider = () => useContext(AiProviderContext);

